import React, {useLayoutEffect, useRef, useState} from 'react';
import {Template} from "../../../components/template/template.jsx";
import Button from "../../../components/button/button.jsx";
import {FaPrint} from "react-icons/fa6";
import {useQuery} from "@tanstack/react-query";
import {Card} from "../../../components/card/card.jsx";
import clonesService from "../../../services/web/clones-service.js";
import {useSearchParams} from "react-router";
import HeaderTemplateButton from "../../../components/button/header-template-button.jsx";
import PrintTemplate from "../../../components/reports/print-reports/print-template.jsx";
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const initial = {
    renavam: "",
    uuid: "",
    attach1: "",
    info1: "",
    attach2: "",
    info2: ""
}
const CloneInfo = () => {
    const [clone, setClone] = useState(initial)
    const [searchParams] = useSearchParams();
    const idToSearch = searchParams.get("id");
    const [headerSelected, setHeaderSelected] = useState(-1);
    const printComponentRef = useRef(null);
    const [isLoadingPrint, setIsLoadingPrint] = useState(false);
    const [canPrint, setCanPrint] = useState(false);

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const {isLoading} = useQuery({
        queryFn: async () => {
            const fetchedData = await clonesService.searchNotificationById({id: idToSearch}).then(({data}) => {
                return data
            })

            if (fetchedData) {
                setClone(fetchedData);

                await delay(500);

                setCanPrint(true);
            }

            return fetchedData || [];
        },
        queryKey: ['clone', idToSearch]
    })

    useLayoutEffect(() => {
        if (canPrint) printComponentRef.current?.print()
    }, [canPrint]);

    return (
        <Template isLoading={isLoading || isLoadingPrint}>
            <Template.Header className={"print-hide absolute!"}>
                <div className="flex justify-between w-full">
                    <Template.Title>
                        Verificação de clone
                    </Template.Title>
                    <div className={"flex flex-row h-7.5 gap-2"}>
                        <Button title={'Imprimir relatório'} onClick={() => printComponentRef.current?.print()}>
                            <FaPrint />
                        </Button>
                        <HeaderTemplateButton selected={headerSelected} setSelected={setHeaderSelected} />
                    </div>
                </div>
            </Template.Header>
            <Template.Body>
                <div className={"bg-white p-4"}>
                    <PrintTemplate
                        entity={headerSelected}
                        title={"Verificação de clone"}
                        ref={printComponentRef}
                        setIsPrinting={setIsLoadingPrint}
                        landscape={true}
                    >
                        <div className={"min-w-full min-h-full bg-white"}>
                            <div className="flex flex-col items-center mb-3 mt-3 gap-2">
                                <div className="vehicle-plate">
                                    <div className={"product-heading " + (clone.plate?.pattern ?? 'WITHOUT_PATTERN')}></div>
                                    <div className={"product-body " + (clone.plate?.pattern ?? 'WITHOUT_PATTERN')}>
                                        {clone.plate?.formattedValue}
                                    </div>
                                </div>

                                <div className="text-sm font-light">
                                    { "Sem informações"}
                                </div>

                                <div className="text-xs font-light">
                                    {clone?.uuid}
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4 mb-3 print:p-8">
                                <Card notShowInPrint={false}>
                                    <Card.Header >
                                        <Card.Title className={"w-full text-center"}>
                                            Passagem 1
                                        </Card.Title>
                                    </Card.Header>
                                    <Card.Body className="p-4 grow">
                                        <div className="flex flex-col items-center justify-center">
                                            <img className="mx-auto max-h-136 max-w-[95%] rounded-[0.2em]"
                                                 src={`${API_KEEPER}/ged/attach/${ clone?.attach1 }`}
                                                 alt={clone?.attach1}
                                            />

                                            {clone?.info1 &&
                                                <div className="mt-4 w-full">
                                                    <p className="mb-2">Nome da corporação: <b className="font-bold text-gray-900">{clone?.info1?.entityName}</b></p>
                                                    <p className="mb-2">Endereço do PCL: <b className="font-bold text-gray-900">{clone?.info1?.laneAddressFormatted}</b></p>
                                                    <p>Data/hora da passagem: <b className="font-bold text-gray-900">{clone?.info1?.captureTime}</b></p>
                                                </div>
                                            }
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Card notShowInPrint={false}>
                                    <Card.Header >
                                        <Card.Title className={"w-full text-center"}>
                                            Passagem 2
                                        </Card.Title>
                                    </Card.Header>

                                    <Card.Body className="p-4 grow">
                                        <div className="flex flex-col items-center justify-center">
                                            <img className="mx-auto max-h-136 max-w-[95%] rounded-[0.2em]"
                                                 src={`${API_KEEPER}/ged/attach/${ clone?.attach2 }`}
                                                 alt={clone?.attach2}
                                            />

                                            {clone?.info2 &&
                                                <div className="mt-4 w-full">
                                                    <p className="mb-2"> Nome da corporação: <b className="font-bold text-gray-900">{clone.info2?.entityName}</b></p>
                                                    <p className="mb-2">Endereço do PCL: <b className="font-bold text-gray-900">{clone.info2?.laneAddressFormatted}</b></p>
                                                    <p>Data/hora da passagem: <b className="font-bold text-gray-900">{clone.info2?.captureTime}</b></p>
                                                </div>
                                            }
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </div>
                    </PrintTemplate>
                </div>
            </Template.Body>
        </Template>
    );
};

export default CloneInfo;